module.exports = __webpack_public_path__ + "static/media/dashboard-logo.c3de88ac.svg";